module.exports = __webpack_public_path__ + "img/01.178d419e.png";